import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { Redirect } from 'react-router-dom'

import { funcionContext } from '../../context/funcionContext'


export class MensajeAccion extends Component {
    displayName = MensajeAccion.name

    constructor(props) {
        super(props);

        this.state = {
            mensajeAccion: [],
            mensajeBtn: [],
            loading: true,
            recogerEnvio: false,
            rechazarEnvio: false,
            volver: false,
            guardarEnvio: false,
            accionGuardar: "",
            numeroGuia: props.numeroGuia,
            idModulo: props.idModulo,
            token: props.token,
            idCliente: props.idCliente,
            paisConfirma: props.idPais,
            idciudadConfirma: props.idCiudad,
            nombreConfirma: props.nombreConfirma,
            telefonoConfirma: props.telefonoConfirma,
            telefonoBaseConfirma: "",
            ciudadConfirma: props.ciudadConfirma,
            direccionBaseConfirma: props.direccionBaseConfirma,
            direccionConfirma: "",
            datosAdicionalDir: "",
            fechaConfirma: "",
            habilEntregaoficina: true,
            valorPagar: props.valorPagar,

            mensajesBtnsRecoger: [],
            accionRecoger: ""
        };

    }

    componentDidMount() {
        this.consultarMensaje(2);
        if (this.state.idCliente.length > 0) {
            fetch(window.env.API_DOMAIN_ADDR + '/api/parametros/GetSucursalConfirmacion/' + this.state.idCliente + '/' + this.state.paisConfirma + '/' + this.state.idciudadConfirma, {
                headers: {
                    'authorizedtoken': this.state.token,
                    'user': window.env.API_USER,
                    'refnumber': this.state.numeroGuia
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.codigo != 1) {//Habilitada entrega en oficina
                        this.setState({ habilEntregaoficina: false });
                    }

                });
        } 
    }

    consultarMensaje(paso) {
        let funcion = this.context;
        fetch(window.env.API_DOMAIN_ADDR + '/api/parametros/MensajeConfirmacion/' + funcion + '/' + paso + '/' + this.state.idModulo, {
                headers: {
                    'authorizedtoken': this.state.token,
                    'user': window.env.API_USER,
                    'refnumber': this.state.numeroGuia
                }
            })
            .then(response => response.json())
            .then(data => {
                this.setState({ mensajeAccion: data});

                fetch(window.env.API_DOMAIN_ADDR + '/api/parametros/MensajeBtnConfirmacion/' + funcion + '/' + data.flujo + '/' + this.state.idModulo, {
                    headers: {
                        'authorizedtoken': this.state.token,
                        'user': window.env.API_USER,
                        'refnumber': this.state.numeroGuia
                    }
                })//El 1 correpsonde al paso 1 llamado por defecto en el primer llamado de la pagina
                    .then(response => response.json())
                    .then(dataBtn => {
                        this.setState({ mensajeBtn: dataBtn, loading: false });
                });

            });
        
    }

    aceptarAccion = () => {
        this.setState({ loading: true});
        this.consultarMensaje(3);
    }

    aceptarAccionDomicilio = () => {
        this.consultarMensaje(4);
        this.setState({
            direccionConfirma: this.state.direccionBaseConfirma
        });
    }

    rechazarAccion = (accion) => {
        this.setState(
            { rechazarEnvio: true, accionGuardar: accion }
        );
    }

    recogerEnvio = (accion, msj_1, msj_2) => {
        let msj = [msj_1, msj_2];
        this.setState(
            { recogerEnvio: true, accionRecoger: accion, mensajesBtnsRecoger: msj}
        );
    }

    setVolver = () => {
        this.setState({
            volver: true
        });
    }

    setGuardar = (accion) => {
        if (this.state.mensajeAccion.flujo == 3 || this.state.mensajeAccion.flujo == 7) {//En caso de ser direccion
            this.state.telefonoConfirma = this.state.mensajeAccion.flujo == 3 ? this.state.telefonoBaseConfirma : this.state.telefonoConfirma;
            if (this.state.direccionConfirma != "") {
                let dir = this.state.direccionConfirma.replace(/\//gi, " ");
                dir = dir.replace(/\"/gi, " ");
                fetch(window.env.API_DOMAIN_ADDR + '/api/Confirmacion/CheckGeoReferencia/' + this.state.paisConfirma + '/' + this.state.idciudadConfirma + '/' + encodeURIComponent(dir), {
                        headers: {
                            'authorizedtoken': this.state.token,
                            'user': window.env.API_USER,
                            'refnumber': this.state.numeroGuia
                        }
                    })
                    .then(response => response.json())
                    .then(data => {
                        var dir = data.mensaje.includes("GeorreferenciarResult") ? JSON.parse(data.mensaje) : null;
                        if (dir == null) {
                            this.setState({
                                accionGuardar: accion,
                                guardarEnvio: true
                            });
                        }else if (dir.GeorreferenciarResult.EstadoId == "B") {
                            this.setState({
                                accionGuardar: accion,
                                direccionConfirma: dir.GeorreferenciarResult.Direccion,
                                guardarEnvio: true
                            });
                        } else {
                            this.setState({
                                accionGuardar: accion,
                                guardarEnvio: true
                            });
                        }
                    });
            } else {
                alert("No ha proporcionado ninguna dirección de envío");
            }
        } else if (this.state.mensajeAccion.flujo == 5) {//En caso de ser fecha
            this.state.telefonoConfirma = this.state.telefonoBaseConfirma;
            if (this.state.direccionConfirma != "") {
                let dir = this.state.direccionConfirma.replace(/\//gi, " ");
                dir = dir.replace(/\"/gi, " ");
                fetch(window.env.API_DOMAIN_ADDR + '/api/Confirmacion/CheckGeoReferencia/' + this.state.paisConfirma + '/' + this.state.idciudadConfirma + '/' + encodeURIComponent(dir), {
                    headers: {
                        'authorizedtoken': this.state.token,
                        'user': window.env.API_USER,
                        'refnumber': this.state.numeroGuia
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        var dir = data.mensaje.includes("GeorreferenciarResult") ? JSON.parse(data.mensaje) : null;
                        if (dir == null) {
                            this.setState({
                                accionGuardar: accion
                            });
                        } else if (dir.GeorreferenciarResult.EstadoId == "B") {
                            this.setState({
                                accionGuardar: accion,
                                direccionConfirma: dir.GeorreferenciarResult.Direccion
                            });
                        } else {
                            this.setState({
                                accionGuardar: accion
                            });
                        }
                    });
            } else {
                alert("No ha proporcionado ninguna dirección de envío");
            }
            if (this.state.fechaConfirma != "") {
                let fechaValidacion = new Date(this.state.fechaConfirma);
                let hoy = new Date(); //Fecha actual
                if (hoy > fechaValidacion) {
                    alert("la fecha no puede ser menor a la fecha actual");
                } else {
                    this.setState({
                        accionGuardar: accion,
                        guardarEnvio: true
                    });
                }
            } else {
                alert("No ha proporcionado ninguna fecha");
            }
        } else {
            this.setState({
                accionGuardar: accion,
                guardarEnvio: true
            });
        }
    }

    handleInputChange = (e) => {
        const target = e.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    static renderMensajeAccion(mensajeAccion,c) {
        switch (mensajeAccion.flujo) {
            case 2: //SI o NO
                return (
                    <form>
                        <Grid fluid className="grid alertquestion">
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <label>{mensajeAccion.mensaje}</label>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <input type="button" onClick={() => c.rechazarAccion(c.state.mensajeBtn[1].id)} className="secundary" value={c.state.mensajeBtn[1].mensaje} />
                                    <input type="button" onClick={c.aceptarAccion} className="main" value={c.state.mensajeBtn[0].mensaje} />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <input type="button" onClick={c.setVolver} className="secundary" value={c.state.mensajeBtn[2].mensaje} />
                                </Col>
                            </Row>
                        </Grid>
                    </form>
                );
                break;
            case 3: //Render confirmar dirección
                return (
                    <form>
                        <Grid fluid className="grid alertquestion">
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <label>{mensajeAccion.mensaje}</label>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <div className="input">
                                        <label>Dirección entrega</label>
                                        <input type="text" name="direccionConfirma" value={c.state.direccionConfirma} onChange={c.handleInputChange} maxLength={150} />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <div className="input">
                                        <label>Datos adicionales a la dirección</label>
                                        <input type="text" name="datosAdicionalDir" value={c.state.datosAdicionalDir} onChange={c.handleInputChange} maxLength={150} />
                                    </div>
                                </Col>
                            </Row>
                            <Row style={{ display: (c.context == 8330 || c.context == 8337) ? "none" : "block" }}>
                                <Col sm={10} className="gridCol t">
                                    <div className="input">
                                        <label>Teléfono</label>
                                        <input type="number" name="telefonoBaseConfirma" value={c.state.telefonoBaseConfirma} onChange={c.handleInputChange} maxLength="15" onInput={c.maxLengthCheck} />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <input type="button" onClick={() => c.recogerEnvio(c.state.mensajeBtn[2].generA_SOLUCION_CONFIRMACION ? c.state.mensajeBtn[2].id : "", c.state.mensajeBtn[2].mensaje, c.state.mensajeBtn[3].mensaje)} style={{ display: (c.state.habilEntregaoficina == true ? '' : 'none') }} className="secundary" value={c.state.mensajeBtn[1].mensaje} />
                                    <input type="button" onClick={() => c.setGuardar(c.state.mensajeBtn[0].generA_SOLUCION_CONFIRMACION ? c.state.mensajeBtn[0].id : "")} className="main" value={c.state.mensajeBtn[0].mensaje} />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <input type="button" onClick={c.setVolver} className="secundary" value={c.state.mensajeBtn[3].mensaje} />
                                </Col>
                            </Row>
                        </Grid>
                    </form>
                );
                break;
            case 4: //SI o NO (Con mensaje)
                return (
                    <form>
                        <Grid fluid className="grid alertquestion">
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <label>{mensajeAccion.mensaje.replace("{}", c.state.valorPagar)}</label>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <input type="button" onClick={() => c.rechazarAccion(c.state.mensajeBtn[1].id)} className="secundary" value={c.state.mensajeBtn[1].mensaje} />
                                    <input type="button" onClick={c.aceptarAccion} className="main" value={c.state.mensajeBtn[0].mensaje} />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <input type="button" onClick={c.setVolver} className="secundary" value={c.state.mensajeBtn[2].mensaje} />
                                </Col>
                            </Row>
                        </Grid>
                    </form>
                );
                break;
            case 5: //(Render confirmar fecha)
                return (
                    <form>
                        <Grid fluid className="grid alertquestion">
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <label>{mensajeAccion.mensaje}</label>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <div className="input">
                                        <label>Elegir fecha de entrega</label>
                                        <span><img src="/media/images/Calendario.png" /></span><input type="date" name="fechaConfirma" value={c.state.fechaConfirma} onChange={c.handleInputChange} />
                                    </div>
                                </Col>
                            </Row>
                            <Col sm={10} className="gridCol t">
                                <div className="input">
                                    <label>Teléfono</label>
                                    <input type="number" name="telefonoBaseConfirma" value={c.state.telefonoBaseConfirma} onChange={c.handleInputChange} maxLength="15" onInput={c.maxLengthCheck} />
                                </div>
                            </Col>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <div className="input">
                                        <label>Dirección entrega</label>
                                        <input type="text" name="direccionConfirma" value={c.state.direccionConfirma} onChange={c.handleInputChange} maxLength={150} />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <div className="input">
                                        <label>Datos adicionales a la dirección</label>
                                        <input type="text" name="datosAdicionalDir" value={c.state.datosAdicionalDir} onChange={c.handleInputChange} maxLength={150} />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <input type="button" onClick={() => c.recogerEnvio(c.state.mensajeBtn[3].generA_SOLUCION_CONFIRMACION ? c.state.mensajeBtn[3].id : "", c.state.mensajeBtn[3].mensaje, c.state.mensajeBtn[1].mensaje)} style={{ display: (c.state.habilEntregaoficina == true ? '' : 'none') }} className="secundary" value={c.state.mensajeBtn[2].mensaje} />
                                    <input type="button" onClick={() => c.setGuardar(c.state.mensajeBtn[0].generA_SOLUCION_CONFIRMACION ? c.state.mensajeBtn[0].id : "")} className="main" value={c.state.mensajeBtn[0].mensaje} />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <input type="button" onClick={c.setVolver} className="secundary" value={c.state.mensajeBtn[1].mensaje} />
                                </Col>
                            </Row>
                        </Grid>
                    </form>
                );
                break;
            case 6: //SI -  NO - Domicilio
                return (
                    <form>
                        <Grid fluid className="grid alertquestion">
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <label>{mensajeAccion.mensaje}</label>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <input type="button" onClick={() => c.rechazarAccion(c.state.mensajeBtn[1].id)} className="secundary" value={c.state.mensajeBtn[1].mensaje} />
                                    <input type="button" onClick={() => c.recogerEnvio(c.state.mensajeBtn[4].generA_SOLUCION_CONFIRMACION ? c.state.mensajeBtn[4].id : "", c.state.mensajeBtn[4].mensaje, c.state.mensajeBtn[5].mensaje)} style={{ display: (c.state.habilEntregaoficina == true ? '' : 'none') }} className="secundary" value={c.state.mensajeBtn[0].mensaje} />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <input type="button" onClick={c.aceptarAccionDomicilio} className="secundary" value={c.state.mensajeBtn[2].mensaje} />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <input type="button" onClick={c.setVolver} className="secundary" value={c.state.mensajeBtn[3].mensaje} />
                                </Col>
                            </Row>
                        </Grid>
                    </form>
                );
                break;
            case 7: //Render confirmar dirección domicilio
                return (
                    <form>
                        <Grid fluid className="grid alertquestion">
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <label>{mensajeAccion.mensaje}</label>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <div className="input">
                                        <label>Nombre</label>
                                        <input type="text" name="nombreConfirma" value={c.state.nombreConfirma} maxLength={150} />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <div className="input">
                                        <label>Dirección entrega</label>
                                        <input type="text" name="direccionConfirma" value={c.state.direccionConfirma} onChange={c.handleInputChange} maxLength={150} />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <div className="input">
                                        <label>Datos adicionales a la dirección</label>
                                        <input type="text" name="datosAdicionalDir" value={c.state.datosAdicionalDir} onChange={c.handleInputChange} maxLength={150} />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <div className="input">
                                        <label>Teléfono</label>
                                        <input type="number" name="telefonoConfirma" value={c.state.telefonoConfirma} onChange={c.handleInputChange} maxLength="15" onInput={c.maxLengthCheck} />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <input type="button" onClick={c.setVolver} className="secundary" value={c.state.mensajeBtn[1].mensaje} />
                                    <input type="button" onClick={() => c.setGuardar(c.state.mensajeBtn[0].generA_SOLUCION_CONFIRMACION ? c.state.mensajeBtn[0].id : "")} className="main" value={c.state.mensajeBtn[0].mensaje} />
                                </Col>
                            </Row>
                        </Grid>
                    </form>
                );
                break;
        }
    }

    render() {
        if (this.state.guardarEnvio  == true) {
            switch (this.state.mensajeAccion.flujo) {
                case 3: //Direccion
                    return <Redirect to={{
                        pathname: '/MensajeFinal',
                        state: { numeroGuia: this.state.numeroGuia, direccionConfirma: this.state.direccionConfirma, direccionAdicional: this.state.datosAdicionalDir, nombreConfirma: this.state.nombreConfirma, telefonoConfirma: this.state.telefonoConfirma, token: this.state.token, idModulo: this.state.idModulo, funcion: this.context, accionGuardar: this.state.accionGuardar }
                    }}
                    />;
                    break;
                case 5: //Fecha
                    return <Redirect to={{
                        pathname: '/MensajeFinal',
                        state: { numeroGuia: this.state.numeroGuia, direccionConfirma: this.state.direccionConfirma, direccionAdicional: this.state.datosAdicionalDir, fechaConfirma: this.state.fechaConfirma, telefonoConfirma: this.state.telefonoConfirma, token: this.state.token, idModulo: this.state.idModulo, funcion: this.context, accionGuardar: this.state.accionGuardar }
                    }}
                    />;
                    break;
                case 7: //Direccion
                    return <Redirect to={{
                        pathname: '/MensajeFinal',
                        state: { numeroGuia: this.state.numeroGuia, direccionConfirma: this.state.direccionConfirma, direccionAdicional: this.state.datosAdicionalDir, nombreConfirma: this.state.nombreConfirma, telefonoConfirma: this.state.telefonoConfirma, token: this.state.token, idModulo: this.state.idModulo, funcion: this.context, accionGuardar: this.state.accionGuardar }
                    }}
                    />;
                    break;
               default: //Confirmacion sin datos
                    return <Redirect to={{
                        pathname: '/MensajeFinal',
                        state: { numeroGuia: this.state.numeroGuia, token: this.state.token, idModulo: this.state.idModulo, funcion: this.context, accionGuardar: this.state.accionGuardar }
                    }}
                    />;
                    break;
            }
        }

        if (this.state.rechazarEnvio == true) {
            return <Redirect to={{
                pathname: '/MensajeFinal',
                state: { numeroGuia: this.state.numeroGuia, rechazo: true, token: this.state.token, idModulo: this.state.idModulo, funcion: this.context, accionGuardar: this.state.accionGuardar }
            }}
            />;
        }

        if (this.state.recogerEnvio == true) {
            return <Redirect to={{
                pathname: '/RecogerEnvio',
                state: { numeroGuia: this.state.numeroGuia, idPais: this.state.paisConfirma, idCiudad: this.state.idciudadConfirma, token: this.state.token, idModulo: this.state.idModulo, funcion: this.context, mensajesBtns: this.state.mensajesBtnsRecoger, accion: this.state.accionRecoger }
            }}
            />;              
        }

        if (this.state.volver == true) {
            window.location.reload();
        }

        let content = this.state.loading
            ? <p><em>Loading...</em></p>
            : MensajeAccion.renderMensajeAccion(this.state.mensajeAccion,this);

        return (
            

            <div style={{ textAlign: "center" }}>
                {content}
                <a className="terminos" target="_blank" href="/PdfViewer">Terminos y condiciones</a>
            </div>
        );
    }
}

MensajeAccion.contextType = funcionContext;
